import { Column, Section, Title, Container } from 'rbx'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Header } from './Header/Header'
import './styles.scss'
import { DevelopmentNotification } from '../shared/DevelopmentNotification'

export const Layout = ({ children, breadcrumb, controllerName }) => {
  return (
    <>
      <ToastContainer />
      <Header />
      <Section id="main" className="layout">
        <Container className="">
          <DevelopmentNotification />
          <Title subtitle size={4} className='has-text-grey mb-2'>
            { controllerName }
          </Title>
          <Column.Group centered>
            <Column>
              { children }
            </Column>
          </Column.Group>
        </Container>
      </Section>
    </>
  )
}
